const uiTranslations = {
  cookie_consent: {
    message:
      "Vi bruker informasjonskapslar for å sikre at du får den beste opplevinga på nettstaden vår.",
    learn_more: "Les meir",
    accept: "Aksepter",
    decline: "Avslå",
  },
}

export default uiTranslations
